<template>
  <div class="layout-topbar" v-if="this.$store.state.auth.status.loggedIn">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <button
      class="p-link layout-menu-button"
      @click="onMenuToggle"
      v-tooltip="'Mostrar/Ocultar menu'"
    >
      <span class="pi pi-bars"></span>
    </button>
    <div class="layout-topbar-icons">
      <i
        class="pi pi-gift p-mr-4"
        style="font-size: 20px; width: 30px; cursor: pointer"
        v-tooltip.left="'Feriados, Aniversários e Ausentes'"
        @click="$emit('toggle-who-is-out')"
      ></i>

      <i
        v-if="can('seeFreeTimesSupport')"
        class="pi pi-clock p-mr-4"
        style="font-size: 20px; width: 30px; cursor: pointer"
        v-tooltip.left="'Técnicos sem marcações'"
        @click="$emit('toggle-free-times')"
      ></i>

      <button class="p-link" @click="logout()" v-tooltip.left="'Logout'">
        <span class="layout-topbar-icon pi pi-sign-out"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  },
};
</script>
<style scope>
.p-tooltip {
  z-index: 1000 !important;
}
.layout-topbar {
  z-index: 1000 !important;
}
</style>
